// 🔴 L2 (N°876) — client HTTP des écrans ARTISAN (client → site → dossier).
//
// 🔑 CAS C (N°877) : ce module ⛔ n'appelle QUE `/api/metier/*` et
// `/api/governance/*`. ⛔ Aucune route du DAL gelé, ni importée,
// ni recopié — vérifié par `garde_frontiere_artisan.test.js`.
const API = process.env.REACT_APP_BACKEND_URL || "";
const e = encodeURIComponent;

function entetes() {
  let jeton = null;
  try { jeton = localStorage.getItem("session_token"); } catch { /* indisponible */ }
  return { "Content-Type": "application/json",
           ...(jeton && { Authorization: `Bearer ${jeton}` }) };
}

export async function appel(chemin, options = {}) {
  const r = await fetch(`${API}${chemin}`, { credentials: "include",
                                             headers: entetes(), ...options });
  const j = await r.json().catch(() => ({}));
  if (!r.ok) {
    const d = j?.detail;
    // 12/10 — l'erreur PORTE son statut HTTP : l'appelant peut distinguer un refus métier d'un état transitoire sans relire le texte seul.
    const erreur = new Error(typeof d === "string" ? d : (d?.message || `Échec (HTTP ${r.status})`));
    erreur.status = r.status;
    if (Array.isArray(d?.bloquants)) erreur.bloquants = d.bloquants;      // refus 409 : ce qui bloque (« dossier X », « devis émis Y »)
    throw erreur;
  }
  return j;
}

// 🔴 12/10 — « GÉNÉRATION EN COURS ». Le pont répond 409 avec ce motif quand une AUTRE demande
//    est en train de créer le devis de la même visite (double clic, deux appareils).
// ⛔ Ce n'est PAS un refus du devis : la visite ne doit pas être rouverte, son devis est en train
//    de naître. ⚠️ Le serveur n'a qu'un statut (409) pour les deux cas : on reconnaît celui-ci à
//    son motif, figé côté serveur par test_mario_devis_depuis_releve_double_clic_force.
export const estGenerationDevisEnCours = (erreur) =>
  erreur?.status === 409 && /génération du devis de cette visite est déjà en cours/i.test(erreur?.message || "");

export const sitesDuClient = (clientId) =>
  appel(`/api/metier/clients/${e(clientId)}/sites`);
export const lireSite = (siteId) => appel(`/api/metier/sites/${e(siteId)}`);
// 🔴 P1 (lot S) — modifier / supprimer un site (le serveur : id ET tenant, anti-doublon, garde de références, devis émis non réécrits).
export const modifierSite = (siteId, data) => appel(`/api/metier/sites/${e(siteId)}`, { method: "PATCH", body: JSON.stringify(data) });
export const supprimerSite = (siteId) => appel(`/api/metier/sites/${e(siteId)}`, { method: "DELETE" });
export const creerSite = (clientId, data) =>
  appel(`/api/metier/clients/${e(clientId)}/sites`,
        { method: "POST", body: JSON.stringify(data) });
export const rattacherSite = (dossierId, siteId) =>
  appel(`/api/metier/dossiers/${e(dossierId)}/site`,
        { method: "POST", body: JSON.stringify({ site_id: siteId }) });
export const creerDossierSurSite = (clientId, siteId, activite) =>
  appel("/api/metier/dossiers", { method: "POST",
    body: JSON.stringify({ client_id: clientId, site_id: siteId, activite }) });
export const devisDuDossier = (dossierId) =>
  appel(`/api/metier/devis?dossier_id=${e(dossierId)}`);
// 🔴 N°966 — Devis → Facture par la capacité PARTAGÉE OH Facturation (⛔ aucun
//    endpoint spécifique Mario) : éligibilité (devis déjà facturé / facturable) et
//    création depuis devis. Le serveur applique capability `commercial.factures`,
//    porte VH3, mentions légales, numérotation et idempotence (index unique).
export const eligibiliteFactures = (devisIds) =>
  appel("/api/metier/factures/eligibilite",
        { method: "POST", body: JSON.stringify({ devis_ids: devisIds }) });
// 🔴 N°975 — émettre un devis brouillon par la route NATIVE partagée (la même que
//    `DevisFacturesTab` pour un devis « draft ») : numéro, gel, identité légale, GED.
export const emettreDevis = (devisId) =>
  appel(`/api/metier/devis/${e(devisId)}/emettre`, { method: "POST" });
// LOT D — `options` facultatif : { type_facture: "acompte"|"intermediaire"|"solde", pourcentage }.
//    Sans options, le corps est identique à celui d'avant.
export const creerFactureDepuisDevis = (devisId, options) =>
  appel("/api/metier/factures/depuis-devis",
        { method: "POST", body: JSON.stringify({ devis_id: devisId, ...(options || {}) }) });
export const pipelinesDuTenant = () => appel("/api/governance/pipelines");
// 🔴 N°975 — Relevé → Devis par le PONT SERVEUR existant (Mario V1 · B) : valorisé par
//    le catalogue, idempotent (un relevé = un devis), ⛔ aucune logique métier ici.
export const creerDevisDepuisReleve = (releveId) =>
  appel(`/api/metier/mario/sessions/${e(releveId)}/devis`, { method: "POST" });
// 🔴 N°1016 — les VISITES (relevés de chantier) vues par l'ERP : MÊME donnée que l'écran terrain,
//    ⛔ aucune copie ailleurs. Une visite close sans devis peut être rouverte (le serveur décide).
export const visitesDuDossier = (dossierId) =>
  appel(`/api/metier/mario/dossiers/${e(dossierId)}/visites`);
export const visitesDuTenant = (etat) =>
  appel(`/api/metier/mario/visites${etat ? `?etat=${e(etat)}` : ""}`);
export const rouvrirVisite = (releveId) =>
  appel(`/api/metier/mario/sessions/${e(releveId)}/rouvrir`, { method: "POST" });
/** PDF d'un devis, lu AVEC la session (⛔ un simple lien n'emporte pas l'en-tête
 *  d'authentification) : la route documentaire PARTAGÉE, ⛔ aucun rendu ici. */
export async function pdfDevis(devisId) {
  const r = await fetch(`${API}/api/metier/documents/devis/${e(devisId)}/pdf`,
                        { credentials: "include", headers: entetes() });
  if (!r.ok) {
    const j = await r.json().catch(() => ({}));
    throw new Error(typeof j?.detail === "string" ? j.detail : `PDF indisponible (HTTP ${r.status})`);
  }
  return r.blob();
}

/** L'activité DÉCLARÉE par le tenant (`config.dossier_activite`) — ⛔ jamais devinée. */
export function activiteDuTenant() {
  try { return localStorage.getItem("current_dossier_activite") || null; } catch { return null; }
}
